import React, { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

const TAB_HASH = {
  dashboard: "dashboard",
  devices: "iot",
  sources: "sources",
  transformations: "transformations",
  endpoints: "endpoints",
  logs: "logs",
};

const ApiManagerTool = () => {
  const { tab = "dashboard" } = useParams();
  const location = useLocation();

  const src = useMemo(() => {
    const token = localStorage.getItem("token");
    const hash = TAB_HASH[tab] || "dashboard";
    const params = new URLSearchParams({ embed: "1" });
    if (new URLSearchParams(location.search).get("create") === "1" && hash === "endpoints") {
      params.set("action", "new-endpoint");
    }
    if (token) params.set("saasToken", token);
    return `/api-manager/admin?${params.toString()}#${hash}`;
  }, [location.search, tab]);

  return (
    <div className="h-[calc(100vh-112px)] min-h-[680px] overflow-hidden rounded-xl border border-slate-200 bg-white">
      <iframe
        key={src}
        title="API Manager Tool"
        src={src}
        className="h-full w-full border-0"
      />
    </div>
  );
};

export default ApiManagerTool;
